import React from "react";

import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";

import BackArrow from "../../assets/icons/BackArrow.svg";
// import { TrackingContext } from "../../bit/tracking";
// import useEventTracking from "../../bit/tracking/useEventTracking";

interface BackButtonProps {
  to: string;
}

const StyledButton = styled("button")(({ theme }) => ({
  color: theme.palette.primary.main,
  path: {
    fill: theme.palette.primary.main,
  },
}));

const BackButton = ({ to }: BackButtonProps) => {
  const navigate = useNavigate();

  // const { getPageData } = useContext(TrackingContext);

  // const { trackEvent } = useEventTracking();

  return (
    <StyledButton
      className="back-button"
      onClick={() => {
        // const pageData = getPageData();

        // if (pageData) {
        // trackEvent({ type: "back_button_click", value: pageData.page });
        // }

        navigate(to);
      }}
    >
      <BackArrow width="7rem" />
    </StyledButton>
  );
};

export default React.memo(BackButton);
